// extracted by mini-css-extract-plugin
export default {"pagi-container":"Pagination_pagi-container__KBVuV","active":"Pagination_active__PRX0a"};